import React, {useEffect, useRef, useState} from "react";
import {useNavigate, useLocation, Form} from "react-router-dom";
import Header from './base/HeaderComponent'
import Footer from "./base/FooterComponent";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import './Login.css';
import './Profile.css';
import {
    useCreateChatMutation,
    useChatsQuery,
    useMeQuery,
    useLazyOperatorsQuery,
    useSetAvailabilityMutation, useAvailabilityQuery
} from "../services/endpoints/user.api";
import CalendarWithModal from "./CalendarComponent";
const ProfileOperator = () => {
    const navigate = useNavigate(); // Usa useNavigate per ottenere la funzione di navigazione

    const [createChat, { isLoading }] = useCreateChatMutation(); // Hook RTK
    const [setSlots, { isSetSlotsLoading }] = useSetAvailabilityMutation(); // Hook RTK
    const [triggerGetOperators, { data: operatorsData, isLoading: isLoadingOperators }] = useLazyOperatorsQuery();
    const [room, setRoom] = useState('');
    const [showChatRoom, setShowChatRoom] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null); // <-- errore locale
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [message, setMessage] = useState("");
    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);

    const [events, setEvents] = useState([]); // eventi da mostrare nel calendario
    const { data: slotsData, isLoading: isAvailabilityLoading,   isSuccess: isAvailabilitySuccess} = useAvailabilityQuery();


    function toUTCWithOffset(date) {
        const offsetMs = date.getTimezoneOffset() * 60 * 1000;
        return new Date(date.getTime() - offsetMs).toISOString();
    }
    const parseSlotToLocalDate = (isoString) => {
        const [datePart, timePart] = isoString.split('T');
        const [year, month, day] = datePart.split('-').map(Number);
        const [hour, minute] = timePart.split(':').map(Number);

        // month va da 0 a 11 in JavaScript
        return new Date(year, month - 1, day, hour, minute);
    };
    const handleSubmitDisp = async (e) => {
        e.preventDefault();

        if (!startDateTime || !endDateTime) {
            return setMessage("Inserisci entrambe le date e ore.");
        }

        if (endDateTime <= startDateTime) {
            return setMessage("La data di fine deve essere successiva a quella di inizio.");
        }

        const slots = [];
        let current = new Date(startDateTime);
        const end = new Date(endDateTime);

        // Normalizza all'inizio della giornata
        // current.setHours(0, 0, 0, 0);

        while (current <= end) {
            // const dateStr = current.toISOString().split("T")[0];
            // const start = createLocalDateTime(dateStr, startDateTime.toTimeString().slice(0, 5));
            // const endSlot = createLocalDateTime(dateStr, endDateTime.toTimeString().slice(0, 5));
            const start = current;
            const endSlot = end;

            if (endSlot > start) {
                slots.push({
                    start: toUTCWithOffset(start),
                    end: toUTCWithOffset(endSlot),
                });
            }
            current.setDate(current.getDate() + 1);
        }

        const updatedEvents = [...events]; // snapshot locale
        const newValidSlots = slots.filter(slot => {
            const isDuplicate = updatedEvents.some(existing =>
                existing.start === slot.start && existing.end === slot.end
            );
            if (!isDuplicate) {
                updatedEvents.push({ start: slot.start, end: slot.end }); // Simula aggiunta
                return true;
            }
            return false;
        });


        if (newValidSlots.length === 0) {
            return setMessage("Nessuno slot nuovo da aggiungere (tutti duplicati).");
        }

        try {
            const response = await setSlots({ slots: newValidSlots }).unwrap();

            if (response) {
                const calendarEvents = newValidSlots.map(slot => ({
                    title: "Disponibile",
                    start: parseSlotToLocalDate(slot.start),
                    end: parseSlotToLocalDate(slot.end),
                }));
                setEvents(prev => [...prev, ...calendarEvents]);
                setMessage("Disponibilità salvate con successo.");
                setStartDateTime(null);
                setEndDateTime(null);
            }
        } catch (err) {
            console.error(err);
            setMessage("Errore durante il salvataggio.");
        }
    };


    const { data: userData, isLoading: isMeLoading, isSuccess } = useMeQuery(undefined, {
        pollingInterval: 30000, // ogni 60.000 ms = 1 minuto
        skip: false, // ogni 60.000 ms = 1 minuto
    });
    const { data: chatsData, isLoading: isChatsLoading, isChatsSuccess } = useChatsQuery(undefined, {
        pollingInterval: 30000, // ogni 60.000 ms = 1 minuto
        skip: false, // ogni 60.000 ms = 1 minuto
    });

    let finalData = userData;

    // Redirigi se non è autenticato
    useEffect(() => {
        if (isMeLoading && !isSuccess) {
            navigate("/login");
        }
    }, [isSuccess, isMeLoading, navigate ]);

    useEffect(() => {
        if (isAvailabilitySuccess && slotsData?.slots) {
            const formattedSlots = slotsData.slots.map(slot => ({
                title: "Disponibile",
                start: parseSlotToLocalDate(slot.start),
                end: parseSlotToLocalDate(slot.end),
            }));
            setEvents(formattedSlots);
        }
    }, [isAvailabilitySuccess, slotsData]);

    const goToChat = async () => {
        window.open(process.env.REACT_APP_ROCKET_CHAT_API
        +'/home?resumeToken=' + localStorage.getItem('token'), '_blank');
    };



    return (
        <div>
            <Header />
            <section className="h-100 gradient-custom-2">
                <div className="container py-5 h-100">
                    <div className="row d-flex justify-content-center">
                        <div className="col col-lg-9 col-xl-8">
                            <div className="card">
                                <div
                                    className="rounded-top text-white d-flex flex-row"
                                    style={{ backgroundColor: '#000', height: '200px' }}
                                >
                                    <div className="ms-4 mt-5 d-flex flex-column" style={{ width: '150px' }}>
                                        <img
                                            src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-profiles/avatar-1.webp"
                                            alt="Generic placeholder"
                                            className="img-fluid img-thumbnail mt-4 mb-2"
                                            style={{ width: '150px', zIndex: 1 }}
                                        />
                                        {/*<button*/}
                                        {/*    type="button"*/}
                                        {/*    className="btn btn-outline-dark text-body"*/}
                                        {/*    style={{ zIndex: 1 }}*/}
                                        {/*>*/}
                                        {/*    Edit profile*/}
                                        {/*</button>*/}
                                    </div>
                                    <div className="ms-3" style={{ marginTop: '130px' }}>
                                        <h5>{finalData?.data.name}</h5>
                                        {/*<p>New York</p>*/}
                                    </div>
                                </div>

                                <div className="p-4 text-black bg-body-tertiary">
                                    <div className="d-flex justify-content-end text-center py-1 text-body">
                                        {/*<div className="d-flex align-items-center gap-2">*/}
                                        {/*    <span className={`status-dot ${finalData?.firestoreUser.activeSession ? "online" : "offline"}`}></span>*/}
                                        {/*    <div>*/}
                                        {/*        <p className="small text-muted mb-0">Sessione attiva</p>*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                        <div className="px-3">
                                            <p className="mb-1 h5">{finalData?.firestoreUser.numChats}</p>
                                            <p className="small text-muted mb-0">Numero sessioni</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body p-4 text-black">
                                    {/* Nav Tabs */}
                                    <ul className="nav nav-tabs mb-4" id="profileTabs" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link active" id="disp-tab" data-bs-toggle="tab" data-bs-target="#disp" type="button" role="tab">
                                                Disponibilità
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link" id="chat-tab" data-bs-toggle="tab" data-bs-target="#chat" type="button" role="tab">
                                                Chat Attive
                                            </button>
                                        </li>
                                    </ul>

                                    {/* Contenuto delle Tabs */}
                                    <div className="tab-content" id="profileTabsContent">
                                        {/* TAB DISPONIBILITÀ */}
                                        <div className="tab-pane fade show active" id="disp" role="tabpanel" aria-labelledby="disp-tab">
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    {/* Form disponibilità */}
                                                    <form onSubmit={handleSubmitDisp} className="p-4 border rounded bg-light">
                                                        <div className="mb-3">
                                                            <label className="form-label">Data & Ora Inizio </label><br/>
                                                            <DatePicker
                                                                selected={startDateTime}
                                                                onChange={(date) => setStartDateTime(date)}
                                                                showTimeSelect
                                                                dateFormat="Pp"
                                                                timeFormat="HH:mm"
                                                                className="form-control"
                                                                placeholderText="Seleziona data e ora"
                                                            />
                                                        </div>

                                                        <div className="mb-3">
                                                            <label className="form-label">Data & Ora Fine< /label><br/>
                                                            <DatePicker
                                                                selected={endDateTime}
                                                                onChange={(date) => setEndDateTime(date)}
                                                                showTimeSelect
                                                                dateFormat="Pp"
                                                                timeFormat="HH:mm"
                                                                className="form-control"
                                                                placeholderText="Seleziona data e ora"
                                                            />
                                                        </div>

                                                        <button type="submit" className="btn btn-primary">Aggiungi Disponibilità</button>
                                                        {message && <div className="mt-3 alert alert-info">{message}</div>}
                                                    </form>

                                                </div>

                                                <div className="col-sm-6 align-content-center float-end">
                                                    <CalendarWithModal events={events} />
                                                </div>
                                            </div>
                                        </div>

                                        {/* TAB CHAT ATTIVE */}
                                        <div className="tab-pane fade" id="chat" role="tabpanel" aria-labelledby="chat-tab">
                                            <div className="mb-4 text-body">
                                                <h5>Chat Attive</h5>
                                            </div>

                                            {chatsData?.success && chatsData.data.length > 0 ? (
                                                <div className="table-responsive">
                                                    <table className="table table-striped">
                                                        <thead>
                                                        <tr>
                                                            <th>Nome stanza</th>
                                                            <th>Utente</th>
                                                            <th>Azione</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {chatsData.data.map((chat, index) => (
                                                            <tr key={index}>
                                                                <td>{chat.name}</td>
                                                                <td>{chat.user}</td>
                                                                <td>
                                                                    <button
                                                                        className="btn btn-primary btn-sm"
                                                                        onClick={() => {
                                                                            const token = localStorage.getItem('token');
                                                                            const url = process.env.REACT_APP_ROCKET_CHAT_API
                                                                                + `/home?resumeToken=${token}&redirect=/group/${chat.name}`;
                                                                            window.open(url, '_blank');
                                                                        }}
                                                                    >
                                                                        Vai alla chat
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <p className="text-muted">Nessuna chat attiva</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );

};

export default ProfileOperator;
